export function getAgefromDateOfBirth(dateOfBirth: Date): number {
    if (dateOfBirth == null || dateOfBirth == undefined){
       return 0;
    }
   const today = new Date();    
   let age = today.getFullYear() - dateOfBirth.getFullYear();
   const m = today.getMonth() - dateOfBirth.getMonth();

   if (m < 0 || (m === 0 && today.getDate() < dateOfBirth.getDate())) {
     age--;
   }

   return age;
}